module.exports = __webpack_public_path__ + "img/workload.84cd6055.png";